"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreTooltip = _interopRequireDefault(require("@vfuk/core-tooltip"));
var _coreMatchMedia = require("@vfuk/core-match-media");
var _coreBaseProps = require("@vfuk/core-base-props");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var BreadcrumbText = function BreadcrumbText(_ref) {
  var text = _ref.text,
    id = _ref.id,
    isSideBreadcrumbsItem = _ref.isSideBreadcrumbsItem,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var _useBreakpoints = (0, _coreMatchMedia.useBreakpoints)(),
    mdAndAbove = _useBreakpoints.mdAndAbove;
  if (text.length > 20 && mdAndAbove && !isSideBreadcrumbsItem) return /*#__PURE__*/_react["default"].createElement(_coreTooltip["default"], {
    id: id,
    text: text,
    appearance: "secondary",
    size: 2,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, "".concat(text.substring(0, 20), "..."));
  return /*#__PURE__*/_react["default"].createElement("span", {
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, text);
};
BreadcrumbText.displayName = "BreadcrumbText";
var _default = BreadcrumbText;
exports["default"] = _default;
//# sourceMappingURL=BreadcrumbText.js.map